// extracted by mini-css-extract-plugin
export default {"mid-box":"HospitalLinkage_mid-box__nWr23","link-btn":"HospitalLinkage_link-btn__qYSTq","past":"HospitalLinkage_past__IWOYx"};